import React from 'react';
import GenericModal from './GenericModal';

export default function TagModal({
  isOpen,
  onClose,
  mode = 'whitelist',
  column = '',
  values = [],
  onRemoveValue,
  onClearAll,
  onMoveAll,
  onToggleValue,
}) {
  const colorClasses = mode === 'blacklist'
    ? {
        badge: 'bg-red-600 text-white',
        chip: 'bg-red-700',
      }
    : {
        badge: 'bg-blue-600 text-white',
        chip: 'bg-blue-700',
      };

  return (
    <GenericModal isOpen={isOpen} onClose={onClose} draggable dragHandleSelector=".tag-modal-header" hideTopRightClose>
      <div className="text-white">
        {/* Invisible top drag handle spanning full width (no top-right X anymore) */}
        <div className="absolute top-0 left-0 right-0 h-6 tag-modal-header cursor-grab active:cursor-grabbing" />
        <div className="flex items-center justify-between mb-3 tag-modal-header select-none cursor-grab active:cursor-grabbing">
          <h2 className="text-lg font-semibold">
            {column} ({values?.length || 0})
          </h2>
          <span className={`text-xs px-2 py-1 rounded ${colorClasses.badge} pointer-events-none select-none`}>
            {mode === 'blacklist' ? 'Excluded' : 'Included'}
          </span>
        </div>

        {(!values || values.length === 0) ? (
          <p className="text-sm text-gray-300">No values selected.</p>
        ) : (
          <div className="w-full overflow-y-auto max-h-80 pr-1">
            {/* Variable-width tags; container scrolls vertically */}
            <div className="flex flex-wrap items-start content-start gap-2 pb-2">
              {values.map((value) => (
                <span
                  key={`${column}-${value}`}
                  className={`px-3 py-1 rounded-full text-sm inline-flex items-center ${colorClasses.chip} text-white w-auto max-w-max shrink-0 self-start cursor-pointer`}
                  title={mode === 'blacklist' ? 'Move to Included' : 'Move to Excluded'}
                  onClick={() => onToggleValue && onToggleValue(value)}
                >
                  {value === '(Blank)' ? <i>(Blank)</i> : 
                    value.length > 30 ? `${value.substring(0, 30)}...` : value}
                  <button
                    type="button"
                    className={`ml-2 px-1 rounded ${colorClasses.remove} p-2 -m-2`}
                    onClick={(e) => { e.stopPropagation(); onRemoveValue && onRemoveValue(value); }}
                    aria-label={`Remove ${value}`}
                  >
                    ×
                  </button>
                </span>
              ))}
            </div>
          </div>
        )}

        <div className="mt-6 flex justify-end gap-2">
          {values && values.length > 0 && (
            <button
              type="button"
              className={`${mode === 'blacklist' ? 'bg-blue-600 hover:bg-blue-500' : 'bg-red-600 hover:bg-red-500'} px-3 py-1 rounded text-white`}
              onClick={() => {
                if (onMoveAll) onMoveAll();
                if (onClose) onClose();
              }}
            >
              {mode === 'blacklist' ? 'Move All to Included' : 'Move All to Excluded'}
            </button>
          )}
          {values && values.length > 0 && (
            <button
              type="button"
              className="px-3 py-1 rounded bg-gray-600 hover:bg-gray-500 text-white"
              onClick={() => {
                if (onClearAll) onClearAll();
                if (onClose) onClose();
              }}
            >
              Clear All
            </button>
          )}
          <button
            type="button"
            className="px-3 py-1 rounded bg-gray-500 hover:bg-gray-400 text-white"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </GenericModal>
  );
}


